import { useCallback } from 'react'
import { useStaff } from '@/api/hooks'
import { formatActorName } from '@/lib/actors'

/** Resolves stored actor ids to staff names using the shared staff directory. */
export function useActorName() {
  const { data: staff } = useStaff()
  return useCallback((value: string | null | undefined) => formatActorName(value, staff), [staff])
}
